<template>
  <div class="productPrice">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @periodChange="periodChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="false"
        :columns="columnListDefault"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          type="index"
          :title="$t('productPrice.table.sortNo')"
          width="80"
        ></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <el-dialog
      :title="this.$t('productPrice.title.importPeriodNameSelect')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="350px"
    >
      <base-form
        v-model="baseData"
        :options="options"
        ref="baseData"
        @input="handleChangeBaseData"
        label-width="100px"
      ></base-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="handleImport()">{{
          $t('dialog.confirm')
        }}</el-button>
      </div>
    </el-dialog>
    <sirui-upload
      :data="importData"
      :action="importUrl"
      fileList=".xls,.xlsx"
      v-on:getData="getResultData"
      ref="siruiUpload"
    >
    </sirui-upload>
    <import-result ref="dialog" :importDataResult="importDataResult" />
    <!-- 导入的原料价格确认 -->
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/productCenter/productPrice';
  import siruiUpload from '@/components/SiruiUpload';
  import SiruiSearch from '@/components/SiruiSearch';
  import tableMixins from '@/common/mixins/table.js';
  import DataBaseAPI from '@/api/dataBase';
  import baseForm from '@/components/form/base-form';
  // import { dateFormat } from '@/filters';
  import importResult from './components/importResult';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'productPrice',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      baseForm,
      siruiUpload,
      importResult,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      baseUrl() {
        return baseUrl;
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //原料编码
          {
            name: this.$t('productPrice.search.productCode'),
            prop: 'productCode',
            type: 'input',
          },
          //原料名称
          {
            name: this.$t('productPrice.search.productName'),
            prop: 'productName',
            type: 'input',
          },
          //规格型号
          {
            name: this.$t('productPrice.search.productSpec'),
            prop: 'productSpec',
            type: 'input',
          },
          {
            // 账期
            prop: 'periodName',
            name: this.$t('productPrice.search.periodName'),
            type: 'searchTableSpec',
            searchType: 'pdPeriod',
            isMultiple: true,
            extraData: {
              projectCode: this.query.projectCode,
            },
            currentValue: this.query.periodName,
            changeMethod: 'periodChange',
          },
          {
            // 业务部门
            prop: 'businessDepartmentCode',
            name: this.$t('productPrice.search.businessDepartmentName'),
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
        ];
      },
      options() {
        return [
          {
            // 账期
            prop: 'periodName',
            label: this.$t('productPrice.label.periodName'),
            type: 'searchTable',
            searchType: 'pdPeriod',
            required: true,
            isMultiple: true,
            span: 18,
            extraData: {
              projectCode: this.baseData.projectCode,
              periodStatus: 'opened',
            },
            currentValue: this.baseData.periodName,
          },
        ];
      },
    },
    data() {
      return {
        action: API.LIST_PRODUCTPRICE_IMPORT,
        dialogAdd: false,
        loading: false,
        multipleSelection: [],
        menuButtonList: [],
        importData: {}, // 导入参数
        importUrl: '', // 导入地址
        tableData: [],
        load: false,
        query: {
          productCode: null,
          productName: null,
          productSpec: null,
          businessDepartmentCode: null,
          periodCode: null,
          periodName: null,
          //projectCode: null, // 项目名称
        },
        baseData: {
          periodCode: null, //账期编码
          periodName: null, //账期
        },
        importDataResult: {
          periodCode: null, //账期编码
          periodName: null, //账期
          projectCode: null, //项目编码
          projectName: null, //项目名称
        },
        projectNameShow: null,
        reportDateShow: null,
        companyList: [],
        departmentList: [],
        columnListDefault: [
          // { type: "checkbox", width: "50", fixed: "left" }, // 复选框
          //原料编码
          { field: 'productCode', title: 'productPrice.column.productCode', visible: true },
          //原料名称
          { field: 'productName', title: 'productPrice.column.productName', visible: true },
          //规格型号
          { field: 'productSpec', title: 'productPrice.column.productSpec', visible: true },
          //账期编码
          { field: 'periodCode', title: 'productPrice.column.periodCode' },
          //账期名称
          { field: 'periodName', title: 'productPrice.column.periodName' },
          //所属项目
          {
            field: 'projectName',
            title: 'productPrice.column.projectName',
            visible: true,
            dictType: 'produce_product_proname',
          },
          //部门名称
          { field: 'businessDepartmentName', title: 'productPrice.column.businessDepartmentName' },
          //当前价格
          { field: 'productPrice', title: 'productPrice.column.productPrice', visible: true },
          //价格状态
          {
            field: 'priceStatus',
            title: 'productPrice.column.priceStatus',
            visible: true,
            dictType: 'produce_product_status',
          },
        ],
      };
    },
    mounted() {
      //this.getData();
      this.getCompany();
      this.getButtonList();
      this.setImport();
      this.$nextTick(() => {
        //设置导入参数
        this.setImport();
      });
    },
    methods: {
      // 获取列表数据
      async getData() {
        if (!this.query.periodName) {
          return this.tips('noPeriodName', 'error');
        }
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = JSON.parse(JSON.stringify(this.query));
        params = Object.assign(params, { pageNum, pageSize });
        let res = await this.$axios.post(API.LIST_PRODUCTPRICE_BY_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      periodChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.query.periodCode = res[0].periodCode;
          this.query.periodName = res[0].periodName;
        } else {
          this.query.periodCode = this.query.periodName = null;
        }
      },
      // 表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'projectCode') {
          this.baseData.periodCode = this.baseData.periodName = null;
          this.baseData.projectCode = value.projectCode;
          this.baseData.projectName = this.$baseRequest.getDictValueByType(
            'produce_product_proname',
            value.projectCode
          );
        }
        if (prop == 'periodName') {
          let res = value.periodName;
          if (res && res.length > 0) {
            this.baseData.projectCode = this.importDataResult.projectCode = res[0].projectCode;
            this.baseData.projectName = this.importDataResult.projectName = res[0].projectName;
            this.baseData.periodCode = this.importDataResult.periodCode = res[0].periodCode;
            this.baseData.periodName = this.importDataResult.periodName = res[0].periodName;
          } else {
            this.baseData.periodCode =
              this.baseData.periodName =
              this.importDataResult.periodCode =
              this.importDataResult.periodName =
              this.importDataResult.projectCode =
              this.importDataResult.projectName =
                null;
          }
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      // 按钮
      chooseClick(type) {
        if (type == 'del') {
          // 删除
          this.handleDel();
        } else if (type == 'exportData') {
          // 导出
          this.handleExport();
        } else if (type == 'importData') {
          // 导入
          this.dialogAdd = true;
        }
      },

      // 设置导入配置
      setImport() {
        this.importUrl = API.LIST_PRODUCTPRICE_IMPORT;
        let { tenantCode, access_token, companyCode, companyName, departmentCode, departmentName } =
          this.userInfo;
        let createPersonNo = this.userInfo.userCode; //操作人
        let createPersonName = this.userInfo.userName; //操作人
        this.importData = {
          tenantCode,
          access_token,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          createPersonNo,
          createPersonName,
        };
      },
      // 返回表单数据
      exportBaseData() {
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
      handleImport() {
        // 导入
        let baseData = this.exportBaseData();
        if (baseData) {
          this.importData = Object.assign(this.importData, this.baseData);
          this.$refs.siruiUpload.openDialog(true);
          this.dialogAdd = false;
        }
      },
      getResultData() {
        this.$refs.dialog.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.dialog.getData();
        });
      },
      handleExport() {
        // 导出
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'idList=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.LIST_PRODUCTPRICE_EXPORT}?${str}access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.query);
          window.location.href = `${this.baseUrl}${API.LIST_PRODUCTPRICE_EXPORT}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 删除
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('pleaseSelectOne', 'error');
        }
        // let items = this.multipleSelection.map((i) => i.id);
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.$axios.post(API.DELETE_SETTLESUMMARY, {}).then((res) => {
              if (0 == res.data.code) {
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                this.resetBtnClick();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`productPrice.message.${info}`),
          type: type,
        });
      },
    },
  };
</script>
